import type { DocumentModel } from '@/models/document.model';
import { CrudService } from './crud.service';

export class PricatService {
  private crudService: CrudService<DocumentModel>;

  constructor() {
    this.crudService = new CrudService<DocumentModel>('pricat');
  }

  public async downloadPricat(accountId: string, seasonName: string) {
    const queryParams = new URLSearchParams();
    queryParams.set('accountId', accountId);
    queryParams.set('seasonName', seasonName);

    return this.crudService.doWithCustomType<DocumentModel>('get', `download-pricat?${queryParams}`);
  }
}
